module.exports = __webpack_public_path__ + "assets/8e7b70e15eef8f24793632aa365b892f.png";